import {useLocation, useSearchParams, useNavigate, useParams} from 'react-router-dom';
import {useCallback} from 'react';

// Web-specific globals
declare const window: {
  history: {replaceState: (data: any, title: string, url: string) => void};
  location: {pathname: string};
};

// Web routing hook using react-router-dom
export function useRouting() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const params = useParams();

  const getRouteParam = useCallback(
    (key: string): string | null => {
      const value = params[key];
      return value !== undefined ? String(value) : null;
    },
    [params],
  );

  const getSearchParam = useCallback(
    (key: string): string | null => {
      return searchParams.get(key);
    },
    [searchParams],
  );

  const clearSearchParams = useCallback(() => {
    window.history.replaceState({}, '', window.location.pathname);
  }, []);

  const navigateTo = useCallback(
    (path: string, options?: {replace?: boolean}) => {
      navigate(path, options);
    },
    [navigate],
  );

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return {
    pathname: location.pathname,
    locationKey: location.key,
    getRouteParam,
    getSearchParam,
    clearSearchParams,
    navigateTo,
    goBack,
  };
}
